// Zeichenzähler „64 / 500“ (DESIGN §3.6.3): `small` `fg-tertiary`, ab 90 % `warning-fg`;
// optional Mindestlänge „80 characters minimum · 46 to go“ (§3.6.4).
import { cn } from '../../basis/kern';

export function charCountText(length: number, max?: number, min?: number): string {
  if (min !== undefined && length < min) return `${min} characters minimum · ${min - length} to go`;
  return max !== undefined ? `${length} / ${max}` : String(length);
}

export function CharCount({
  id,
  length,
  max,
  min,
  className,
}: {
  id?: string;
  length: number;
  max?: number;
  min?: number;
  className?: string;
}) {
  const warn = max !== undefined && length >= max * 0.9;
  return (
    <span
      id={id}
      aria-live="polite"
      className={cn(
        'text-small tabular-nums',
        warn ? 'text-warning-fg' : 'text-fg-tertiary',
        className,
      )}
    >
      {charCountText(length, max, min)}
    </span>
  );
}
